export const LIST_QUERY_NAME_SUFFIX = 'List';
export const INDEXED_QUERY_NAME_PREFIX = 'getIndexed';
export const RELATED_QUERY_NAME_PREFIX = 'getRelated';
